import { render, staticRenderFns } from "./photoAndMsgCard.vue?vue&type=template&id=3704b5fe&scoped=true"
import script from "./photoAndMsgCard.vue?vue&type=script&lang=js"
export * from "./photoAndMsgCard.vue?vue&type=script&lang=js"
import style0 from "./photoAndMsgCard.vue?vue&type=style&index=0&id=3704b5fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3704b5fe",
  null
  
)

export default component.exports